import React from "react";
import { Card, Typography, Space } from "antd";
import {
  CalendarOutlined,
  HourglassOutlined,
  NotificationOutlined,
} from "@ant-design/icons";
import styled from "styled-components";
import moment from "moment";
const { Text } = Typography;

const StyledCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  margin-bottom: 24px;
`;

const DateItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const IconBox = styled.div<{ color: string }>`
  width: 40px;
  height: 40px;
  background-color: #f5f5f5;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  color: ${(props) => props.color};
  font-size: 20px;
`;

interface DateProps {
  startDate: string;
  endDate: string;
  evaluationDate: string;
  resultDate: string;
}

const ImportantDates: React.FC<DateProps> = ({
  startDate,
  endDate,
  evaluationDate,
  resultDate,
}) => {
  return (
    <StyledCard
      title={
        <Space>
          <CalendarOutlined style={{ color: "#1890ff" }} />
          <span>Important Dates</span>
        </Space>
      }
    >
      <DateItem>
        <IconBox color="#1890ff">
          <CalendarOutlined />
        </IconBox>
        <div>
          <Text type="secondary" style={{ fontSize: "12px", display: "block" }}>
            START DATE - END DATE
          </Text>
          <Text strong>
            {moment(startDate).format("MMM D, hh:mm A")} —{" "}
            {moment(endDate).format("MMM D, hh:mm A")}
          </Text>
        </div>
      </DateItem>

      <DateItem>
        <IconBox color="#faad14">
          <HourglassOutlined />
        </IconBox>
        <div>
          <Text type="secondary" style={{ fontSize: "12px", display: "block" }}>
            EVALUATION DATE
          </Text>
          <Text strong>
            {evaluationDate == null
              ? "-"
              : moment(evaluationDate).format("MMM D, hh:mm A")}
          </Text>
        </div>
      </DateItem>

      <DateItem>
        <IconBox color="#52c41a">
          <NotificationOutlined />
        </IconBox>
        <div>
          <Text type="secondary" style={{ fontSize: "12px", display: "block" }}>
            RESULT DATE
          </Text>
          <Text strong>{moment(resultDate).format("MMM D, hh:mm A")}</Text>
        </div>
      </DateItem>
    </StyledCard>
  );
};

export default ImportantDates;
